import store from '@/store'

/**
 * [検索UI用] 検索テキストを取得する
 * (検索UI初期表示用に渡すパラメータとして使用)
 * @param {*} searchCategory 
 * @returns 
 */
export const getSearchTextInputOfSearchUIParam = (searchCategory) => {
  if (searchCategory === 'qa') {
    return store.state.searchUI.params.qa_search_text_input
  } else if (searchCategory === 'knowledge') {
    return store.state.searchUI.params.knowledge_search_text_input
  } else if (searchCategory === 'book') {
    return store.state.searchUI.params.book_search_text_input
  } else if (searchCategory === 'download') {
    return store.state.searchUI.params.download_search_text_input
  } else if (searchCategory === 'note') {
    return store.state.searchUI.params.note_search_text_input
  } else {
    return ''
  }
}

/**
 * [検索UI用] 曖昧フラグを取得する
 * (検索UI初期表示用に渡すパラメータとして使用)
 * @param {*} searchCategory 
 * @returns 
 */
export const getIsFuzzyInputOfSearchUIParam = (searchCategory) => {
  if (searchCategory === 'qa') {
    return store.state.searchUI.params.qa_is_fuzzy_input
  } else if (searchCategory === 'knowledge') {
    return store.state.searchUI.params.knowledge_is_fuzzy_input
  } else if (searchCategory === 'book') {
    return store.state.searchUI.params.book_is_fuzzy_input
  } else if (searchCategory === 'download') {
    // 書式DLに曖昧フラグは存在しない
  } else if (searchCategory === 'note') {
    // ノートに曖昧フラグは存在しない
  } else {
    return 0
  }
}
